(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "react-router", "../constants", "../StackSwitch/useLocationKey", "./useRouteLocation"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("react-router"), require("../constants"), require("../StackSwitch/useLocationKey"), require("./useRouteLocation"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.reactRouter, global.constants, global.useLocationKey, global.useRouteLocation);
    global.usePreventBackward = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _reactRouter, _constants, _useLocationKey, _useRouteLocation) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.usePreventBackward = usePreventBackward;

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function hasOwnProperty(object, key) {
    return Object.prototype.hasOwnProperty.call(object || {}, key);
  }

  function useKey() {
    var location = (0, _useRouteLocation.useRouteLocation)();
    return (0, _react.useMemo)(function () {
      if (hasOwnProperty(location === null || location === void 0 ? void 0 : location.state, '__prevent')) {
        return location.state.__prevent;
      } else {
        return location.key;
      }
    }, [location]);
  }

  function useHasNext(key) {
    var _useContext = (0, _react.useContext)(_reactRouter.__RouterContext),
        locationHistory = _useContext.locationHistory;

    return (0, _react.useMemo)(function () {
      var nextLocation = locationHistory.getNext(key);

      if (hasOwnProperty(nextLocation === null || nextLocation === void 0 ? void 0 : nextLocation.state, '__prevent') && nextLocation.state.__prevent === key) {
        return true;
      } else {
        return false;
      }
    }, [locationHistory, key]);
  }

  function useIsNext(key) {
    var location = (0, _useRouteLocation.useRouteLocation)();
    return (0, _react.useMemo)(function () {
      return hasOwnProperty(location.state, '__prevent') && location.state.__prevent === key && !location.hash;
    }, [key, location]);
  }

  function useLocationState(key) {
    var _useContext2 = (0, _react.useContext)(_reactRouter.__RouterContext),
        locationHistory = _useContext2.locationHistory;

    return (0, _react.useMemo)(function () {
      return locationHistory.get(key);
    }, [locationHistory, key]);
  }

  function usePreventBackward() {
    var watchLocation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var history = (0, _reactRouter.useHistory)();
    var location = (0, _useRouteLocation.useRouteLocation)();

    var _useContext3 = (0, _react.useContext)(_reactRouter.__RouterContext),
        locationHistory = _useContext3.locationHistory,
        match = _useContext3.match,
        routerIndex = _useContext3.routerIndex;

    var key = useKey();
    var hasNext = useHasNext(key);
    var isNext = useIsNext(key);
    var locationState = useLocationState(key);

    var __lock = (0, _react.useRef)(false);

    var __wait = (0, _react.useRef)(false);

    var refPrevent = (0, _react.useRef)(locationState === null || locationState === void 0 ? void 0 : locationState.prevent);
    (0, _react.useEffect)(function () {
      refPrevent.current = locationState === null || locationState === void 0 ? void 0 : locationState.prevent;
    }, [locationState]);
    var executeCallback = (0, _react.useCallback)(function () {
      var prevent = refPrevent.current;

      if (prevent === true) {
        __lock.current = true;
        history.goForward();
      } else if (typeof prevent === 'function') {
        var result = prevent(); // prevent 가 promise 인 경우, 앞으로 보낸다음, 결과에 따라 동작

        if (result instanceof Promise) {
          __wait.current = true;
          history.goForward();
          result.then(function (r) {
            return r && history.go(-2);
          }).finally(function () {
            return __wait.current = false;
          });
        } else if (result) {
          history.goBack();
        } else {
          __lock.current = true;
          history.goForward();
        }
      }
    }, [history]);
    (0, _react.useLayoutEffect)(function () {
      var prevent = refPrevent.current;
      if (!watchLocation || !match.active) return;

      if (__lock.current) {
        __lock.current = false;
        return;
      }

      if (__wait.current && prevent && !isNext) {
        history.goForward();
      } else if (prevent && location.hash && !location.key) {
        __lock.current = true;
      } else if (match.active && !match.isExact && isNext && !prevent) {
        // return from subroute.
        __lock.current = true;
        history.goBack();
      } else if (match.active && !match.isExact) {
        // return from subroute.
        __lock.current = true;
      } else if (isNext && !prevent && !history.direction) {
        // maybe refresh?
        __lock.current = true;
        history.goBack();
      } else if (isNext && !prevent && history.direction === _constants.BACKWARD) {
        // prevent is not defined, back to normal state.
        __lock.current = true;
        history.goBack();
      } else if (!isNext && !hasNext && prevent && history.direction === _constants.BACKWARD) {
        __lock.current = true;
        history.goBack();
      } else if (!isNext && hasNext && prevent && history.direction === _constants.BACKWARD) {
        // execute callback
        executeCallback();
      } else if (!isNext && hasNext && prevent && history.direction === _constants.FORWARD) {
        // prevent is exist. forward to exist state.
        __lock.current = true;
        history.goForward();
      } else if (isNext && hasNext && !prevent && history.direction === _constants.FORWARD) {
        // go to next route if exist.
        history.goForward();
      } else if (isNext && !prevent && history.direction === _constants.FORWARD) {
        // return to normal state, when if not exist next route.
        history.goBack();
      }
    }, [watchLocation, executeCallback, match, history, location, isNext, hasNext]);
    var setPrevent = (0, _react.useCallback)(function (value) {
      var __key = (0, _useLocationKey.getLocationKeys)(location, routerIndex);

      locationHistory.set(key, {
        prevent: value || undefined
      });

      if (!value && isNext) {
        __lock.current = true;
        history.goBack();
      } else if (value && !isNext) {
        refPrevent.current = value;
        history.push(_objectSpread(_objectSpread({}, location), {}, {
          hash: '',
          state: _objectSpread(_objectSpread({}, location.state || {}), {}, {
            __key: __key,
            __prevent: key
          })
        }));
      }
    }, [isNext, location, history, routerIndex, locationHistory, key]);
    return [refPrevent.current, setPrevent, {
      key: key || 'undefined',
      isNext: isNext,
      hasNext: hasNext
    }];
  }
});